<template>
    <div class="audit-list-container">
        <el-row :gutter="20" class="action-bar">
            <el-col :span="12">
                <el-button type="success" size="small" @click="handleConfig" icon="el-icon-setting"><i class="el-icon-setting"></i> 配置</el-button>
            </el-col>
            <el-col :span="12" class="text-right">
                <el-button type="primary" size="small" @click="goBack"><i class="el-icon-arrow-left"></i> 返回维保计划</el-button>
            </el-col>
        </el-row>

        <el-row :gutter="20" class="statistics-cards">
            <el-col :span="12">
                <div class="stat-card stat-warning">
                    <div class="stat-icon"><i class="el-icon-time"></i></div>
                    <div class="stat-content">
                        <div class="stat-value">{{ pendingAuditCount }}</div>
                        <div class="stat-label">待审核总数</div>
                    </div>
                </div>
            </el-col>
            <el-col :span="12">
                <div class="stat-card stat-info">
                    <div class="stat-icon"><i class="el-icon-document-checked"></i></div>
                    <div class="stat-content">
                        <div class="stat-value">{{ todayAuditCount }}</div>
                        <div class="stat-label">今日已审核</div>
                    </div>
                </div>
            </el-col>
        </el-row>

        <el-tabs v-model="activeTab" type="border-card">
            <el-tab-pane label="全部" name="all">
                <el-table :data="tableData" border stripe v-loading="tableLoading" style="width: 100%">
                    <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                    <el-table-column prop="planNo" label="计划编号" width="150" align="center"></el-table-column>
                    <el-table-column prop="deviceName" label="设备名称" min-width="120" align="center"></el-table-column>
                    <el-table-column prop="maintenanceType" label="维保类型" width="100" align="center">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.maintenanceType === 'routine'" type="info" size="small">日常维保</el-tag>
                            <el-tag v-else-if="scope.row.maintenanceType === 'periodic'" type="primary" size="small">定期维保</el-tag>
                            <el-tag v-else-if="scope.row.maintenanceType === 'seasonal'" type="warning" size="small">季节性维保</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="申请类型" width="100" align="center">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status === 3" type="warning" size="small">延期申请</el-tag>
                            <el-tag v-else-if="scope.row.status === 4" type="primary" size="small">维保完成</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="planDate" label="计划日期" width="110" align="center">
                        <template slot-scope="scope">{{ formatDate(scope.row.planDate) }}</template>
                    </el-table-column>
                    <el-table-column prop="executorName" label="执行人" width="100" align="center"></el-table-column>
                    <el-table-column label="状态" width="100" align="center">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status === 3" type="warning" size="small">待审核延期</el-tag>
                            <el-tag v-else-if="scope.row.status === 4" type="primary" size="small">待审核完成</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="180" fixed="right" align="center">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" @click="handleAudit(scope.row)">审核</el-button>
                            <el-button type="info" size="mini" @click="handleDetail(scope.row)">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>

            <el-tab-pane label="延期申请" name="delay">
                <el-table :data="delayTableData" border stripe v-loading="tableLoading" style="width: 100%">
                    <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                    <el-table-column prop="planNo" label="计划编号" width="150" align="center"></el-table-column>
                    <el-table-column prop="deviceName" label="设备名称" min-width="120" align="center"></el-table-column>
                    <el-table-column prop="planDate" label="原计划日期" width="110" align="center">
                        <template slot-scope="scope">{{ formatDate(scope.row.planDate) }}</template>
                    </el-table-column>
                    <el-table-column prop="deadline" label="原截止日期" width="110" align="center">
                        <template slot-scope="scope">{{ formatDate(scope.row.deadline) }}</template>
                    </el-table-column>
                    <el-table-column prop="delayReason" label="延期原因" min-width="150" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column label="操作" width="180" fixed="right" align="center">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" @click="handleAudit(scope.row)">审核</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>

            <el-tab-pane label="维保完成" name="complete">
                <el-table :data="completeTableData" border stripe v-loading="tableLoading" style="width: 100%">
                    <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                    <el-table-column prop="planNo" label="计划编号" width="150" align="center"></el-table-column>
                    <el-table-column prop="deviceName" label="设备名称" min-width="120" align="center"></el-table-column>
                    <el-table-column prop="executorName" label="执行人" width="100" align="center"></el-table-column>
                    <el-table-column prop="startTime" label="开始时间" width="160" align="center">
                        <template slot-scope="scope">{{ formatDateTime(scope.row.startTime) }}</template>
                    </el-table-column>
                    <el-table-column prop="endTime" label="结束时间" width="160" align="center">
                        <template slot-scope="scope">{{ formatDateTime(scope.row.endTime) }}</template>
                    </el-table-column>
                    <el-table-column prop="result" label="维保结果" min-width="150" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column label="操作" width="180" fixed="right" align="center">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" @click="handleAudit(scope.row)">审核</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>

        <el-dialog title="维保计划详情" :visible.sync="detailDialogVisible" width="650px" :append-to-body="true">
            <el-descriptions :column="2" border>
                <el-descriptions-item label="计划编号">{{ detailData.planNo }}</el-descriptions-item>
                <el-descriptions-item label="维保类型">
                    <el-tag v-if="detailData.maintenanceType === 'routine'" type="info" size="small">日常维保</el-tag>
                    <el-tag v-else-if="detailData.maintenanceType === 'periodic'" type="primary" size="small">定期维保</el-tag>
                    <el-tag v-else-if="detailData.maintenanceType === 'seasonal'" type="warning" size="small">季节性维保</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="设备名称">{{ detailData.deviceName }}</el-descriptions-item>
                <el-descriptions-item label="申请类型">
                    <el-tag v-if="detailData.status === 3" type="warning" size="small">延期申请</el-tag>
                    <el-tag v-else-if="detailData.status === 4" type="primary" size="small">维保完成</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="计划日期">{{ formatDate(detailData.planDate) }}</el-descriptions-item>
                <el-descriptions-item label="截止日期">{{ formatDate(detailData.deadline) }}</el-descriptions-item>
                <el-descriptions-item label="执行人">{{ detailData.executorName || '-' }}</el-descriptions-item>
                <el-descriptions-item label="开始时间">{{ formatDateTime(detailData.startTime) }}</el-descriptions-item>
                <el-descriptions-item label="结束时间">{{ formatDateTime(detailData.endTime) }}</el-descriptions-item>
                <el-descriptions-item label="维保结果" :span="2">{{ detailData.result || '-' }}</el-descriptions-item>
                <el-descriptions-item label="延期原因" :span="2">{{ detailData.delayReason || '-' }}</el-descriptions-item>
                <el-descriptions-item label="备注" :span="2">{{ detailData.remark || '-' }}</el-descriptions-item>
            </el-descriptions>
            <div slot="footer" class="dialog-footer">
                <el-button @click="detailDialogVisible = false" size="small">关 闭</el-button>
            </div>
        </el-dialog>

        <el-dialog
            :title="auditDialogTitle"
            :visible.sync="auditDialogVisible"
            width="500px"
            :append-to-body="true"
            :close-on-click-modal="false"
        >
            <el-form ref="auditForm" :model="auditForm" label-width="100px">
                <el-form-item :label="auditFormLabel">
                    <div v-if="auditForm.type === 'delay'">
                        <p><strong>延期原因：</strong>{{ auditForm.reason || '-' }}</p>
                        <p><strong>原计划日期：</strong>{{ formatDate(auditForm.planDate) }}</p>
                        <p><strong>原截止日期：</strong>{{ formatDate(auditForm.deadline) }}</p>
                        <p><strong>延期至：</strong>{{ auditForm.delayDate || '-' }}</p>
                        <p><strong>预计截止日期：</strong>{{ auditForm.expectedDeadline || '-' }}</p>
                    </div>
                    <div v-else-if="auditForm.type === 'complete'">
                        <p><strong>维保结果：</strong>{{ auditForm.result || '-' }}</p>
                        <p v-if="auditForm.remark"><strong>备注：</strong>{{ auditForm.remark }}</p>
                    </div>
                </el-form-item>
                <el-form-item label="审核备注">
                    <el-input v-model="auditForm.auditRemark" type="textarea" :rows="3" placeholder="请输入审核备注（可选）"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleAuditSubmit(2)" type="danger" size="small" :loading="auditSubmitting">驳 回</el-button>
                <el-button @click="handleAuditSubmit(1)" type="success" size="small" :loading="auditSubmitting">通 过</el-button>
            </div>
        </el-dialog>

        <!-- 配置弹窗 -->
        <el-dialog title="维保配置" :visible.sync="configDialogVisible" width="400px" :append-to-body="true" :close-on-click-modal="false">
            <el-form ref="configForm" :model="configForm" label-width="140px">
                <el-form-item label="最长可延迟天数（天）">
                    <el-input-number
                        v-model="configForm.maxDelayDays"
                        :min="1"
                        :max="365"
                        :disabled="configLoading"
                        controls-position="right"
                        style="width: 100%"
                    ></el-input-number>
                    <div style="color: #909399; font-size: 12px; margin-top: 5px;">申请延期时，延期天数不能超过此限制</div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="configDialogVisible = false" size="small">取 消</el-button>
                <el-button @click="handleConfigSubmit" type="primary" size="small" :loading="configSaving">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getPendingAudits, auditDelay, auditComplete, getMaintenanceConfig, saveMaintenanceConfig, getStatistics } from './api';

export default {
    name: 'MaintenanceAudit',
    data: function() {
        return {
            activeTab: 'all',
            tableData: [],
            delayTableData: [],
            completeTableData: [],
            tableLoading: false,
            activatedLoaded: false,
            pendingAuditCount: 0,
            todayAuditCount: 0,
            detailDialogVisible: false,
            detailData: {},
            auditDialogVisible: false,
            auditSubmitting: false,
            auditForm: {
                id: null,
                type: '',
                planDate: '',
                deadline: '',
                reason: '',
                delayDate: '',
                expectedDeadline: '',
                result: '',
                remark: '',
                auditRemark: ''
            },
            configDialogVisible: false,
            configLoading: false,
            configSaving: false,
            configForm: {
                maxDelayDays: 30
            }
        };
    },
    computed: {
        ...mapGetters(['userInfo']),
        auditDialogTitle: function() {
            return this.auditForm.type === 'delay' ? '审核延期申请' : '审核维保完成';
        },
        auditFormLabel: function() {
            return this.auditForm.type === 'delay' ? '申请信息' : '维保详情';
        }
    },
    mounted: function() {
        this.$nextTick(function() {
            if (!this.activatedLoaded) {
                this.refreshAuditData();
            }
        });
    },
    activated: function() {
        this.activatedLoaded = true;
        this.refreshAuditData();
    },
    methods: {
        refreshAuditData: function() {
            this.loadData();
            this.loadStatistics();
        },
        loadStatistics: function() {
            var self = this;
            getStatistics().then(function(res) {
                var body = res && res.data;
                var data = body && body.data ? body.data : {};
                self.todayAuditCount = Number(data.todayAudited || 0);
            }).catch(function() {
                self.todayAuditCount = 0;
                self.$message.error('获取审核统计失败');
            });
        },
        loadData: function() {
            var self = this;
            self.tableLoading = true;
            getPendingAudits().then(function(res) {
                var body = res && res.data;
                var audits = body && body.data != null ? body.data : body;
                if (!Array.isArray(audits)) {
                    audits = [];
                }
                self.delayTableData = audits.filter(function(item) {
                    return item.status === 3;
                });
                self.completeTableData = audits.filter(function(item) {
                    return item.status === 4;
                });
                self.tableData = self.delayTableData.concat(self.completeTableData);
                self.pendingAuditCount = self.tableData.length;
            }).catch(function() {
                self.delayTableData = [];
                self.completeTableData = [];
                self.tableData = [];
                self.pendingAuditCount = 0;
            }).finally(function() {
                self.tableLoading = false;
            });
        },
        goBack: function() {
            this.$router.push({ path: '/system/device-maintenance/index' });
        },
        handleDetail: function(row) {
            this.detailData = Object.assign({}, row);
            this.detailDialogVisible = true;
        },
        handleAudit: function(row) {
            this.auditForm = {
                id: row.id,
                type: row.status === 3 ? 'delay' : 'complete',
                planDate: row.planDate,
                deadline: row.deadline,
                reason: row.delayReason || '',
                delayDate: row.delayDate ? this.formatDate(row.delayDate) : '',
                expectedDeadline: this.getExpectedDeadline(row),
                result: row.result || '',
                remark: row.remark || '',
                auditRemark: ''
            };
            this.auditDialogVisible = true;
        },
        handleConfig: function() {
            this.configDialogVisible = true;
            this.loadConfig();
        },
        loadConfig: function() {
            var self = this;
            self.configLoading = true;
            getMaintenanceConfig().then(function(res) {
                var body = res && res.data;
                var data = body && body.data ? body.data : {};
                var maxDelayDays = Number(data.maxDelayDays);
                self.configForm.maxDelayDays = Number.isFinite(maxDelayDays) && maxDelayDays > 0 ? maxDelayDays : 30;
            }).finally(function() {
                self.configLoading = false;
            });
        },
        handleConfigSubmit: function() {
            var self = this;
            var maxDelayDays = Number(this.configForm.maxDelayDays);
            if (!Number.isInteger(maxDelayDays) || maxDelayDays < 1 || maxDelayDays > 365) {
                this.$message.warning('最长可延迟天数范围为1-365天');
                return;
            }
            self.configSaving = true;
            saveMaintenanceConfig(maxDelayDays).then(function(res) {
                var body = res && res.data;
                if (body && (body.code === 200 || body.success)) {
                    self.$message.success('配置保存成功');
                    self.configDialogVisible = false;
                } else {
                    self.$message.error((body && body.msg) || '配置保存失败');
                }
            }).finally(function() {
                self.configSaving = false;
            });
        },
        getCurrentAuditor: function() {
            var u = this.userInfo || {};
            return {
                auditorId: u.user_id || u.userId || u.id,
                auditorName: u.real_name || u.realName || u.name || u.nick_name || u.nickName || u.account || ''
            };
        },
        handleAuditSubmit: function(auditResult) {
            var self = this;
            var auditor = this.getCurrentAuditor();
            if (!auditor.auditorId || !auditor.auditorName) {
                this.$message.warning('未获取到当前登录人员信息，请重新登录后再审核');
                return;
            }
            var successMsg = auditResult === 1 ? (self.auditForm.type === 'delay' ? '延期申请已通过' : '维保完成已审核通过') : '已驳回';
            var request = self.auditForm.type === 'delay' ? auditDelay : auditComplete;

            self.auditSubmitting = true;
            request(
                self.auditForm.id,
                auditResult,
                auditor.auditorId,
                auditor.auditorName,
                self.auditForm.auditRemark
            ).then(function(res) {
                if (res && res.data && (res.data.code === 200 || res.data.success)) {
                    self.$message.success(successMsg);
                    self.auditDialogVisible = false;
                    self.refreshAuditData();
                } else {
                    var body = res && res.data;
                    self.$message.error((body && body.msg) || '操作失败');
                }
            }).catch(function(e) {
                self.$message.error((e && e.message) || '操作失败');
            }).finally(function() {
                self.auditSubmitting = false;
            });
        },
        formatDate: function(val) {
            if (!val) return '-';
            if (typeof val === 'string') return val;
            var date = new Date(val);
            var year = date.getFullYear();
            var month = ('0' + (date.getMonth() + 1)).slice(-2);
            var day = ('0' + date.getDate()).slice(-2);
            return year + '-' + month + '-' + day;
        },
        parseDateStart: function(val) {
            if (!val) return null;
            var date = val instanceof Date ? new Date(val.getTime()) : new Date(val);
            if (isNaN(date.getTime())) return null;
            date.setHours(0, 0, 0, 0);
            return date;
        },
        getExpectedDeadline: function(row) {
            var planDate = this.parseDateStart(row.planDate);
            var delayDate = this.parseDateStart(row.delayDate);
            var deadline = this.parseDateStart(row.deadline);
            if (!planDate || !delayDate || !deadline) {
                return '-';
            }
            var days = Math.floor((delayDate.getTime() - planDate.getTime()) / (24 * 60 * 60 * 1000));
            if (days <= 0) {
                return '-';
            }
            deadline.setDate(deadline.getDate() + days);
            return this.formatDate(deadline);
        },
        formatDateTime: function(val) {
            if (!val) return '-';
            if (typeof val === 'string') return val;
            var date = new Date(val);
            var year = date.getFullYear();
            var month = ('0' + (date.getMonth() + 1)).slice(-2);
            var day = ('0' + date.getDate()).slice(-2);
            var hour = ('0' + date.getHours()).slice(-2);
            var minute = ('0' + date.getMinutes()).slice(-2);
            var second = ('0' + date.getSeconds()).slice(-2);
            return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
        }
    }
};
</script>

<style scoped>
.audit-list-container { padding: 20px; }
.action-bar { margin-bottom: 15px; }
.text-right { text-align: right; }
.statistics-cards { margin-bottom: 20px; }
.stat-card { display: flex; align-items: center; padding: 20px; border-radius: 8px; color: #fff; }
.stat-warning { background: linear-gradient(135deg, #f6d365 0%, #fda085 100%); }
.stat-info { background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%); }
.stat-icon { font-size: 40px; margin-right: 20px; opacity: 0.8; }
.stat-content { flex: 1; }
.stat-value { font-size: 32px; font-weight: bold; }
.stat-label { font-size: 14px; opacity: 0.9; }
.el-table { font-size: 13px; }
</style>
